/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
require('./legacy/custom-panel');
require('./redesign/inputs');

window.Swal = require('sweetalert2');

import Vue from 'vue';
import VModal from 'vue-js-modal';
import vuetify from './plugins/vuetify'; // path to vuetify export
import VueClosable from '@ryanburnette/vue-closable';
import momentDurationFormatSetup from 'moment-duration-format';
import VMoment from 'vue-moment';
import moment from "moment";

momentDurationFormatSetup(moment);
moment.locale(Worklog.locale ?? 'de');
Vue.use(VMoment, {
    moment
});
Vue.use(VueClosable);
Vue.use(VModal, {
    dynamic: true,
    dynamicDefaults: {
        clickToClose: true
    }
});

Vue.prototype.window = window;

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
// test

import CostCarrierMonthChart from './Components/Statistic/CostCarrierMonthChart.vue';
import OverTimeWeekChart from './Components/Statistic/OverTimeWeekChart.vue';
import OverTimeMonthChart from './Components/Statistic/OverTimeMonthChart.vue';
import OverTimeYearChart from './Components/Statistic/OverTimeYearChart.vue';
import WorkTimeWeekDayChart from './Components/Statistic/WorkTimeWeekDayChart.vue';
import WorkTimeMonthDayChart from './Components/Statistic/WorkTimeMonthDayChart.vue';
import WorkTimeYearMonthCompareChart from './Components/Statistic/WorkTimeYearMonthCompareChart.vue';
import WorkTimeTable from './Components/Statistic/WorkTimeTable.vue';
import CostCarrierSelect from "./Components/CostCarrierSelect.vue";
import DepartmentSelect from "./Components/DepartmentSelect.vue";
import AuthorizationSelect from "./Components/AuthorizationSelect.vue";
import MultipleCostCarrierSelect from "./Components/MultipleCostCarrierSelect.vue";
import TravelExpenseReportWizard from "./Components/TravelExpenseReport/Wizard.vue";
import Editor from "./Components/Editor.vue";
import MediaLibrary from "./Components/MediaLibrary.vue";
import Organigram from "./Components/Organigram.vue";
import WeekDaySelectMultiple from "./Components/WeekDaySelectMultiple.vue";
import AddButton from "./Components/Redesign/AddButton.vue";
import CheckBox from "./Components/Redesign/CheckBox.vue";
import SearchBox from "./Components/Redesign/SearchBox.vue";
import MemberProfile from "./Components/Redesign/MemberProfile.vue";
import PlayButton from "./Components/Redesign/PlayButton.vue";
import MemberLogin from "./Components/Redesign/MemberLogin.vue";
import PauseButton from "./Components/Redesign/PauseButton.vue";
import ButtonNormal from "./Components/Redesign/ButtonNormal.vue";
import ThumbsUp from "./Components/Redesign/ThumbsUp.vue";
import ThumbsDown from "./Components/Redesign/ThumbsDown.vue";
import ExportButton from "./Components/Redesign/ExportButton.vue";
import StatusYellow from "./Components/Redesign/ExportButton.vue";
import DemoDate from "./Components/Redesign/DemoDate.vue";
import MultiFileUpload from "./Components/Redesign/MultiFileUpload.vue";
import ApplicationAdminTools from "./Components/ApplicationAdminTools.vue";

// User Profile Components
import ProfilePicture from './Components/User/ProfilePicture.vue';
import WorkHourTable from './Components/User/WorkHourTable.vue';

// Redesign Components
import BorderedInput from './Components/Redesign/BorderedInput.vue';
import FoldOutCard from './Components/Redesign/FoldOutCard.vue';
import CustomCostCarrier from './Components/Redesign/CustomCostCarrier.vue';
import DailyWorktimeSelect from './Components/Redesign/DailyWorktimeSelect.vue';
import ApplicationMailAssignToDepartment from './Components/Redesign/ApplicationMails/AssignToDepartment.vue';
import ApplicationMailActionsMenu from './Components/Redesign/ApplicationMails/ActionsMenu.vue';
import ApplicationMailActionsMenuInbox from './Components/Redesign/ApplicationMails/ActionsMenuInbox.vue';
import ApplicationMailActionsMenuInvite from './Components/Redesign/ApplicationMails/ActionsMenuInvite.vue';
import ApplicationMailActionsMenuHr from './Components/Redesign/ApplicationMails/ActionsMenuHR.vue';
import ApplicationDropdownMenu from './Components/Redesign/ApplicationMails/Dropdown.vue';
import TopbarLogoutMenu from './Components/Redesign/Topbar/LogoutMenu.vue';
import WorktimeWeeklyReleaseEdit from './Components/Redesign/WorktimeWeeklyReleaseEdit.vue';

import TravelExpenseReportOverview from './Components/TravelExpenseReport/Overview.vue';
import UserTaxDataForm from './Components/User/TaxDataForm.vue';
import HeavenUserDataImport from './Components/HeavenUserDataImport.vue';
import EmployeeTile from './Components/Redesign/EmployeeTile.vue';
import ContractSalariesInput from './Components/Redesign/ContractSalariesInput.vue';
import ContractVacationDaysInput from './Components/Redesign/ContractVacationDaysInput.vue';
import UsersSelect from './Components/UsersSelect.vue';
import Alerts from './Components/Alerts.vue';
import WorkTimeDeleteButton from "./Components/WorkTime/WorkTimeDeleteButton.vue";
import SkillSelect from "./Components/SkillSelect.vue";
import EmployeeAttendance from "./Components/Statistic/EmployeeAttendance.vue";
import AppfcHome from './Components/AppfcHome.vue';
import FullScreenToggle from "./Components/FullScreenToggle.vue";
import NotificationBox from "./Components/Notifications/NotificationBox.vue";
import MultiSelect from "./Components/MultiSelect.vue";
import LicenceTable from './Components/Licences/LicenceTable.vue';

// Forecast Stuff
import router from './Components/Forecast/Router/router';
import ForecastHelper from './Components/Forecast/ForecastHelper';

import UserAccessForm from './Components/User/AccessForm.vue';
import UserInventoryForm from './Components/User/InventoryForm.vue';

window.ForecastHelper = ForecastHelper;

import VueGoogleCharts from 'vue-google-charts';

Vue.use(VueGoogleCharts)
window.EventBus = new Vue();

// App
window.app = new Vue({
    el: '#main-container',
    vuetify:vuetify,
    router,

    components: {
        CostCarrierMonthChart,
        OverTimeWeekChart,
        OverTimeMonthChart,
        OverTimeYearChart,
        WorkTimeWeekDayChart,
        WorkTimeMonthDayChart,
        WorkTimeYearMonthCompareChart,
        WorkTimeTable,
        CostCarrierSelect,
        ProfilePicture,
        Editor,
        MediaLibrary,
        AuthorizationSelect,
        MultipleCostCarrierSelect,
        Organigram,
        WeekDaySelectMultiple,
        MultiFileUpload,
        ApplicationAdminTools,
        WorkHourTable,

        BorderedInput,
        WorktimeWeeklyReleaseEdit,

        AddButton,
        CheckBox,
        SearchBox,
        MemberProfile,
        PlayButton,
        MemberLogin,
        PauseButton,
        ButtonNormal,
        ThumbsUp,
        ThumbsDown,
        ExportButton,
        StatusYellow,
        DemoDate,
        FoldOutCard,
        CustomCostCarrier,
        DailyWorktimeSelect,
        TravelExpenseReportWizard,

        TravelExpenseReportOverview,
        UserTaxDataForm,
        HeavenUserDataImport,
        EmployeeTile,
        ApplicationMailAssignToDepartment,
        ApplicationMailActionsMenu,
        ApplicationMailActionsMenuInbox,
        ApplicationMailActionsMenuInvite,
        ApplicationMailActionsMenuHr,
        ApplicationDropdownMenu,
        TopbarLogoutMenu,
        
        DepartmentSelect,
        ContractSalariesInput,
        ContractVacationDaysInput,
        AppfcHome,
        UsersSelect,
        Alerts,
        WorkTimeDeleteButton,
        UserAccessForm,
        UserInventoryForm,
        EmployeeAttendance,
        SkillSelect,
        FullScreenToggle,
        NotificationBox,
        LicenceTable,
        MultiSelect,
    },
});
